export const moduleName = 'root';

export const TOGGLE_SIDEBAR = `@${moduleName}/TOGGLE_SIDEBAR`;


const initialState = {
  data: {
    isSidebarOpen: false,
  },
};

export default function root(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case TOGGLE_SIDEBAR:
      return { ...state, data: { ...state.data, isSidebarOpen: payload } };

    default:
      return state;
  }
}

export const toggleSidebar = mode => ({ type: TOGGLE_SIDEBAR, payload: mode });

// getters
export const checkIsSidebarOpen = state => state[moduleName].data.isSidebarOpen;



// WEBPACK FOOTER //
// ./src/Root/redux/root.redux.js